import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface AreaServed {
  id: number;
  city: string;
  state: string;
}

export const useAreasServed = () => {
  return useQuery<AreaServed[]>({
    queryKey: ['areas-served'],
    queryFn: async () => {
      const response = await api.get<{ areas?: AreaServed[]; data?: AreaServed[] } | AreaServed[]>('/api/marketing/articles/areas_served/');
      // Handle both response structures: {areas: [...]} or direct array
      if (Array.isArray(response.data)) {
        return response.data;
      }
      return (response.data as any).areas || (response.data as any).data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};